import { Component, Input, ViewChild } from '@angular/core';
import { SelectComponent } from 'projects/libraries/syslink-components/src/public-api';
import { FilterDescriptor } from 'devextreme/data';
import { SaleCreditNoteHeaderStatusesService } from '../sale-credit-note-header-statuses/sale-credit-note-header-statuses.service';
import { SaleCreditNoteHeaderStatus } from '../sale-credit-note-header-statuses/sale-credit-note-header-status.model';
import { BaseModalComponent } from 'projects/libraries/syslink-components/src/lib/modal/base-modal/base-modal.component';

@Component({
  selector: 'app-sale-credit-note-status-select-modal',
  templateUrl: './sale-credit-note-status-select-modal.component.html',
  styleUrls: ['./sale-credit-note-status-select-modal.component.scss']
})
export class SaleCreditNoteStatusSelectModalComponent extends BaseModalComponent<SaleCreditNoteHeaderStatus>{
  @Input() public selectFilters: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public expand: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public title: string = "Select order status";
  @Input() public content?: string;
  @Input() public data: any;
  @ViewChild('select') select?: SelectComponent;

  constructor(public saleCreditNoteHeaderStatusesService: SaleCreditNoteHeaderStatusesService) {
    super();
  }

}